export default "__VITE_ASSET__C9fU0T7___"